<template>
  <div class="container">
    <router-view />
  </div>
</template>